import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const getTypeOfMeetings = async () => axios.get(Routes.GET_TYPE_OF_MEETINGS);

export const useGetTypeOfMeetings = () =>
  useQuery({
    queryKey: [Keys.TYPE_OF_MEETINGS],
    queryFn: getTypeOfMeetings,
    cacheTime: Infinity,
  });
